module.exports = __webpack_public_path__ + "img/logo_diginamic.3cd2aca9.png";